// Generates a strong password that satisfies the backend policy:
// at least 8 chars with uppercase, lowercase, number, and special character.
export function generatePassword(length = 16) {
  const lower = 'abcdefghijkmnopqrstuvwxyz';
  const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const numbers = '23456789';
  const special = '!@#$%^&*()-_=+';
  const all = lower + upper + numbers + special;

  const randomInt = (max: number) => {
    const arr = new Uint32Array(1);
    crypto.getRandomValues(arr);
    return arr[0] % max;
  };
  const pick = (set: string) => set[randomInt(set.length)];

  // Guarantee at least one of each required class, then fill the rest.
  const chars = [pick(lower), pick(upper), pick(numbers), pick(special)];
  for (let i = chars.length; i < Math.max(length, 8); i += 1) {
    chars.push(pick(all));
  }

  // Fisher-Yates shuffle so the guaranteed chars aren't always at the front.
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = randomInt(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join('');
}
